// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a7f8356f","453":"e5e9132b","455":"a9116bd4","977":"0b0ca781"}[chunkId] + ".chunk.js";
};